<template>
  <div class="basic_magic_number">
    <div class="tooptipPart all_tooptipPart" >
      
        <my_edit_btn
          :module="module"
          :title="$t('widgets_basic_article_classification_index_336')"
        ></my_edit_btn>
        <my_edit_btn
          :module="module"
          tabName="animation"
          :title="$t('widgets_basic_article_classification_edit_330')"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_edit_btn>
        <my_link_btn
          :module="module"
          :title="$t('components_my_link_index_2361')"
           v-if="$store.state.app.view_pattern === 'pc'"
        ></my_link_btn>
        <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
          :title="$t('widgets_basic_article_list_index_414')"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_close_btn>
      
    </div>
    <div
      class="coverPart"
      @click="clickTime"
    >
      <div class="contentPart">
        <set_link
          class="linkPart"
          :sendData="module.data.listArr.link"
          v-if="module.widgets_id !== editID"
        ></set_link>
        <!--  :contenteditable="$store.state.app.view_pattern === 'pc'" -->

        <div
          :id="'editDiv' + module.widgets_id"
          @mousedown.stop
        >
          <!-- pc_pattern mb_pattern 设置不一样 -->
          <div
            class="module_banner basic_magic_number-content"
            :style="{
              height: height + 'px',
              ...backgroundStyle
            }"
          >
            <span
              class="module_banner_text jz_theme_font_color magic-number"
              :id="'countUp' + module.widgets_id"
              :style="{
               ...fontStyle
              }"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import { CountUp } from "countup.js";
export default {
  name: "basic_magic_number",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isHover: false,
      timer: null,
      isLocked: false,
      delay: 0,
      set_timer: null,
      count_up: null
    };
  },
  computed: {
    editID() {
      if (this.$store.state.app.module_Data) {
        return this.$store.state.app.module_Data.widgets_id;
      } else {
        return 0;
      }
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor;
    },
    linear_gradient() {
      //文字渐变
      const pattern = this.font[this.font.radio_val].pattern;
      const linear_gradient = this.font[this.font.radio_val].linear_gradient;
      if (pattern === "linear_gradient") {
        const fontStyle = {};
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage =
          "linear-gradient(" +
          linear_gradient.deg +
          "deg," +
          linear_gradient.start_color +
          linear_gradient.start_pointer +
          "%," +
          linear_gradient.end_color +
          linear_gradient.end_pointer +
          "%)";
        return fontStyle;
      } else {
        return {
          color: this.font[this.font.radio_val].fontColor_globalColor
        };
      }
    },
    font() {
      return this.infor.font;
    },
    background() {
      return this.infor.background;
    },
     backgroundStyle(){
      return this.background_style(this.$store.state.app.view_pattern)
    },
    fontStyle() { // 字PC
      return this.font_style(this.$store.state.app.view_pattern);
    },
    height() {
      return this.infor.height[this.infor.height.radio_val].height;
    },
    animation_set() {
      return this.module.data.animation_set
    }
  },
  mounted() {
    if(this.animation_set.desc === undefined) { // 添加单位
      this.$set(this.animation_set, 'desc', ' ')
    }
    // let infor = this.module.data.pc_widgets_infor;
    if(!(this.$store.state.app.road_type == 1 && this.$store.state.app.view_pattern == 'mb')) {
      this.delay = this.pc_widgets_infor.playSet[this.pc_widgets_infor.playSet.radio_val].delay;
      this.init();
      this.initData();
    }
    
  },
  methods: {
    init() {
      let { start, end, decimalPlaces,  useGrouping, desc} = { ...this.module.data.animation_set }; // floatNum
      let infor = this.pc_widgets_infor;
      // this.module.data.pc_widgets_infor;
      let option = {
        startVal: start,
        decimalPlaces: decimalPlaces, // 小数的位数数
        duration: infor.playSet[infor.playSet.radio_val].duration,
        useGrouping: useGrouping
      };
      if(desc) { // 添加的单位
        option.suffix = desc
      }
      let dom = document.querySelector('.pc_pattern') ?  `countUp${this.module.widgets_id}` : `countUp${this.module.widgets_id}`
      this.count_up = new CountUp(
        dom,
        end,
        option
      );
      // countUp.start();
    },

    initData() {
      if(this.set_timer){
        clearInterval(this.set_timer)
        this.set_timer = null
      }
      // :id="'editDiv' + module.widgets_id"
      let dom = document.getElementById(`editDiv${this.module.widgets_id}`);
      // 判断 要不要产生滚动条
      let client_height =
        window.innerHeight || document.documentElement.clientHeight; // 屏幕高度
      let body_height = document.body.scrollHeight;
      let top_satrt = dom.getBoundingClientRect().top;
      let scroll_dom = document.querySelector('.pc_pattern')  ? window : '.mb_body_view'
      // this.$store.state.app.view_pattern == 'pc' ? window : '.mb_body_view'
    
      if (client_height > body_height || top_satrt < client_height) {
        // 这个
        // console.log('挂件不滚动执行',top_satrt, this.set_timer)
        this.set_timer = setTimeout(() => {
          // this.numberChange()
          if (!this.count_up.error) this.count_up.start();
        }, this.delay * 1000);
      } else {
        // mb_body_view
        $(scroll_dom).scroll(() => {
          let top = dom.getBoundingClientRect().top;
          // console.log('初始化滚动',top, this.set_timer, client_height)
          if (top <= client_height && !this.set_timer) {
            this.set_timer = setTimeout(() => {
              if (!this.count_up.error) this.count_up.start();
              // this.numberChange()
            }, this.delay * 1000);
          }
          // console.log('DOM的offsetTop' ,dom.getBoundingClientRect().top)
        });
      }
    },
  
    clickTime() {
      /* if(this.$store.state.app.view_pattern !== 'pc'){
        return false;
      } */
      let that = this;
      $("#u" + that.module.widgets_id)
        .find(".contentPart")
        .addClass("focusDiv");
      if (this.module.widgets_id === this.editID) {
        return false;
      }
      var range = document.createRange();
      range.selectNodeContents(
        document.getElementById("editDiv" + this.module.widgets_id)
      );
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      // that.templet.set_focus(that.module.widgets_id);
    },
    font_style(type) { // 字体设置
      let fontStyle = {};
      let infor = this[`${type}_widgets_infor`];
      let font = infor.font[
        infor.font.radio_val
      ];
      fontStyle.fontSize = font.fontSize + "px";
      fontStyle.fontFamily = font.fontFamily;
      fontStyle.fontStyle = font.fsItalics;
      fontStyle.fontWeight = font.fsWeight;
      fontStyle.textAlign = font.textAlign;
      fontStyle.textDecoration= font.fontUnderline;
      // this.pc_widgets_infor.height
      fontStyle.lineHeight = this.height + 'px'
      if (font.pattern == "linear_gradient") {
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
      font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
      '%)'
      } else {
        fontStyle.color = font.fontColor_globalColor;
      }
      return fontStyle;
    },
    background_style(type){ // 背景设置
      let background = this[`${type}_widgets_infor`].background
      if (background.radio_val === "hidden") {
        return {
          background: "transparent"
        };
      }
      return {
        backgroundColor: background[
          background.radio_val
        ].color,
        backgroundImage:
          "url(" +
          (background[
            background.radio_val
          ].img || "") +
          ")",
        backgroundSize: background[
          background.radio_val
        ].background_size,
        backgroundRepeat:background[
          background.radio_val
        ].background_repeat,
        backgroundPosition: background[
          background.radio_val
        ].background_position
      };
    }
  },
  watch: {
    '$store.state.app.view_pattern'(val) { // pc  和手机初始化的时候 动态数字初始化
      if(!(this.$store.state.app.road_type == 1 && this.$store.state.app.view_pattern == 'mb')) {
        this.$nextTick(() => {
          this.init();
          this.initData()
        })
      }
    },
    'module.data.animation_set.start'(){
      this.init();
      this.initData()
    },
    'module.data.animation_set.end'() {
      this.init();
      this.initData()
    },
    'module.data.animation_set.desc'() { // 单位变化
      this.init();
      this.initData()
    }
  }
};
</script>

<style scoped lang="scss">
.basic_magic_number{
  .basic_magic_number-content{
    display: flex;
    .magic-number{
      width: 100%;
      flex:1;
      overflow: hidden;
    }
  }
}
.pc_pattern{
  .basic_magic_number-content_mb{
    display: none;
  }
}
.mb_pattern{
  .basic_magic_number-content_pc{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_magic_number/index.vue